if ($(".offer-slider").find(".offer-slider-wrap a").length > 3) {
  var swiper = new Swiper(".offer-slider", {
    slidesPerView: 2.5,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
      },
    },
  });
}

/* Home page slideshow slider */
if ($(".hero").find(".hero-wrap").find("a").length > 1) {
  var hero_swiper = new Swiper(".hero", {
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 3000,
    },
  });

  var heroSwiper = document.querySelector(".hero");
  if (heroSwiper) {
    var heroSwiperVar = heroSwiper.swiper;
    $(".hero").mouseenter(function () {
      heroSwiperVar.autoplay.stop();
    });
    $(".hero").mouseleave(function () {
      heroSwiperVar.autoplay.start();
    });
  }
}

/*    Cart drawer offer text    */
if($(".offer-text").find(".offer").length > 1){
  new Swiper(".offer-text", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 3000,
    },
  });
  
  const drawerOfferSwiper = document.querySelector(".offer-text");
  if (drawerOfferSwiper) {
    var drawerOfferSwiperVar = drawerOfferSwiper.swiper;
    $(".offer-text").mouseenter(function () {
      drawerOfferSwiperVar.autoplay.stop();
    });
    $(".offer-text").mouseleave(function () {
      drawerOfferSwiperVar.autoplay.start();
    });
  }
}

/* Announcement bar slider */
if($(".announcement-slider").find(".announcement").length > 1){
  new Swiper(".announcement-slider", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 5000,
    },
  });
  
  const announceSwiper = document.querySelector(".announcement-slider");
  if (announceSwiper) {
    var announceSwiperVar = announceSwiper.swiper;
    $(".announcement").mouseenter(function () {
      announceSwiperVar.autoplay.stop();
    });
    $(".announcement").mouseleave(function () {
      announceSwiperVar.autoplay.start();
    });
  }
}

/* product grid image slider */
new Swiper(".fet-tab-pro-img-inner", {
  slidesPerView: 1,
  speed: 1000,
  loop: true,
  navigation: {
    nextEl: ".fet-inner-next",
    prevEl: ".fet-inner-prev",
  },
  noSwiping: true,
  noSwipingClass: 'swiper-slide',
});

if ($(".offer-banner-wrap").find(".offer-banner-inner a").length > 1) {
  var swiper = new Swiper(".offer-banner-wrap", {
    slidesPerView: 1.3215,
    spaceBetween: 24,
    speed: 600,
    slideToClickedSlide: true,
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      767: {
        spaceBetween: 30,
        slidesPerView: 1.3215,
      },
      1024: {
        spaceBetween: 50,
      },
      1320: {
        spaceBetween: 80,
      },
    },
  });

  var offerBanner = document.querySelector(".offer-banner-wrap");
  if (offerBanner) {
    var offerBannerVar = offerBanner.swiper;
    $(".offer-banner-wrap").mouseenter(function () {
      offerBannerVar.autoplay.stop();
    });
    $(".offer-banner-wrap").mouseleave(function () {
      offerBannerVar.autoplay.start();
    });
  }
}

new Swiper(".featured-colle", {
  slidesPerView: 1.23,
  speed: 1000,
  spaceBetween: 16,
  navigation: {
    nextEl: ".fet-main-next",
    prevEl: ".fet-main-prev",
  },
  breakpoints: {
    320: {
      spaceBetween: 20,
      slidesPerView: 1.23,
      centeredSlides: true,
    },
    769: {
      spaceBetween: 20,
      slidesPerView: 3,
    },
    1024: {
      spaceBetween: 40,
      slidesPerView: 3,
    },
  },
});

var swiper = new Swiper(".you-like", {
  slidesPerView: 1.5,
  /*centeredSlides: true,*/
  speed: 1000,
  spaceBetween: 24,
  navigation: {
    nextEl: ".fet-main-next",
    prevEl: ".fet-main-prev",
  },
  breakpoints: {
    280: {
      spaceBetween: 24,
      slidesPerView: 1.3,
    },
    565: {
      spaceBetween: 24,
      centeredSlides: false,
      slidesPerView: 2,
    },
    769: {
      spaceBetween: 30,
      slidesPerView: 3,
    },
    991: {
      spaceBetween: 40,
      slidesPerView: 4,
    },
  },
});

var swiper = new Swiper(".cust-reel-main", {
  slidesPerView: 1,
  speed: 1000,
  spaceBetween: 0,
  navigation: {
    nextEl: ".reel-next",
    prevEl: ".reel-prev",
  },
  breakpoints: {
    1024: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    500: {
      slidesPerView: 2,
      spaceBetween: 15,
    }
  }
});


/*var swiper = new Swiper(".fet-tab-img-inner", {
    slidesPerView: 1,
    speed: 1000,
    loop: true,
    navigation: {
        nextEl: ".fet-inner-next",
        prevEl: ".fet-inner-prev",
    }
});*/

$(document).ready(function () {
  $(document).on("click", ".quick-info-overlay.active", function(){
    if($(".quick-info-pop").hasClass("view-active") && $(".size-chart-box").hasClass("over-lay-active") == false){
      $(".quick-info-pop").find(".design-wrap").find(".qv-close").trigger("click");
    }
  });

  setScrollOnColorOption('', 'var-main-class');
  if($(".parent-set-size").length > 0){
    setScrollOnColorOption('', 'parent-set-size');
  }

  /*window.onresize = (event) => {
    setScrollOnColorOption('', 'var-main-class');
    setScrollOnColorOption('', 'parent-set-size');
  };*/

  /*$(document).on('click', '#size-right-button', function(event) {
    $(this).siblings('.design-set-size-tabs').animate({
      scrollLeft: "+=100px"
    }, "slow");
  });

  $(document).on('click', '#size-left-button', function(event) {
    $(this).siblings('.design-set-size-tabs').animate({
      scrollLeft: "-=100px"
    }, "slow");
  });

  $(document).on('click', '#style-right-button', function(event) {
    $(this).siblings('.select-style').animate({
      scrollLeft: "+=300px"
    }, "slow");
  });

  $(document).on('click', '#style-left-button', function(event) {
    $(this).siblings('.select-style').animate({
      scrollLeft: "-=300px"
    }, "slow");
  });*/

  var selectStyle = $('.select-style');
  var chooseStyle = $('.choose-style');
  var selectWidth = selectStyle.width();
  var chooseWidth = chooseStyle.width();
  if(chooseWidth > selectWidth){
    chooseStyle.addClass('active-arrow');
  }
  
});

if (
  $(".happy-parents-wrap").find(".happy-parents-inner .happy-parents-box")
    .length > 3
) {
  var swiper = new Swiper(".happy-parents-wrap", {
    slidesPerView: 1,
    spaceBetween: 12,
    speed: 1000,
    loop: true,
    breakpoints: {
      767: {
        slidesPerView: 2.4,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 3.4,
        spaceBetween: 30,
      },
      1320: {
        slidesPerView: 3.4,
        spaceBetween: 48,
      },
    },
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}

var swiper = new Swiper(".gram-main", {
  slidesPerView: 1.471,
  spaceBetween: 15,
  speed: 1000,
  autoplay: {
    delay: 3000,
  },
  breakpoints: {
    767: {
      slidesPerView: 3.4,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4.471,
      spaceBetween: 24,
    },
  },
});

var swiper3 = new Swiper(".pro-img-thumb", {
  slidesPerView: 5,
  spaceBetween: 24,
  navigation: {
    nextEl: ".thumb-next",
    prevEl: ".thumb-prev",
  },
});

//ProductImageSlider(".pro-img-wrap", swiper3, '');
var proSlider = new Swiper(".pro-img-wrap", {
  slidesPerView: 1.2,
  spaceBetween: 4,
  centeredSlides: true,
  loop: false,
  thumbs: {
    swiper: swiper3,
  },
  pagination: {
    el: ".swiper-paginations",
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
    }
  },
  on: {
    transitionStart: function(){
      var videos = document.querySelectorAll('.swiper-slide video');
      Array.prototype.forEach.call(videos, function(video){
        video.pause();
      });
  
      $('.pro-img-wrap .iframe-video').each(function(){
        this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
      });
  
      if($('.pro-img-wrap').find('iframe.vimeo-video').length !== 0 ){
        var iframe = $('iframe.vimeo-video')[0];
        var player = new Vimeo.Player(iframe);
        player.pause();
      }
    },
    transitionEnd: function(){
      var activeIndex = this.activeIndex;
      var activeSlide = document.querySelector('.pro-img-wrap').getElementsByClassName('swiper-slide')[activeIndex];
      if(activeSlide.querySelector(".thumb_video")){
        var activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
        activeSlideVideo.play();
      }
  
      if(activeSlide.querySelector(".iframe-video")){
        var activeSlideIframe = activeSlide.getElementsByTagName('iframe')[0];
        activeSlideIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
      }
  
      if(activeSlide.querySelector(".vimeo-video")){
        var activeSlideVimeo = activeSlide.getElementsByClassName('vimeo-video')[0];
        var playerVimeo = new Vimeo.Player(activeSlideVimeo);
        playerVimeo.play();
      }
    }
  }
});

var swiper_discount = new Swiper(".discount-box-main", {
  spaceBetween: 0,
  centeredSlides: false,
  slidesPerView: 1,
  /*effect: "fade",*/
  navigation: {
    nextEl: ".dis-next",
    prevEl: ".dis-prev",
  },
});

new Swiper(".mySwiper", {
  slidesPerView: 3,
  loop: false,
  spaceBetween: 16,
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: ".swiper-arrow-right",
    prevEl: ".swiper-arrow-left",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.9,
    },
    390: {
      slidesPerView: 2.4,
    },
    565: {
      slidesPerView: 3,
    },
  },
});

function onchart(event) {
  document.getElementById("overlay-size-chart").classList.add("overlay-active");
  document.body.classList.add("no-scroll");
  if(!event.target.closest(".size-guide")){
    const html_data = event.target.closest("fieldset").querySelector(".page-content").innerHTML;
    event.target.closest("fieldset").querySelector(".page-content").querySelectorAll(".shirt-img").forEach(img => {
      if(img.classList.contains("img-left")){
        document.querySelector(".size-chart-box").classList.add("is-img-left");
      }
    });
    /*if(event.target.closest("fieldset").querySelector(".page-content").querySelector(".shirt-img").classList.contains("img-left")){
      document.querySelector(".size-chart-box").classList.add("is-img-left");
    }*/
    document.querySelector(".size-chart-box").innerHTML = html_data;
  }
  document.getElementById("size-chart").classList.add("over-lay-active");
}

$(document).on('click', '#overlay-size-chart', offchart );

function offchart() {
  document.getElementById("overlay-size-chart").classList.remove("overlay-active");
  document.getElementById("size-chart").classList.remove("over-lay-active");
  if(!document.querySelector(".quick-info-pop").classList.contains("view-active")){
    document.body.classList.remove("no-scroll");
  }
  //document.body.classList.remove("no-scroll");
  $(document).find('.size-chart-box').removeClass("media-popup");
  document.getElementById("size-chart").innerHTML = '';
  setTimeout(function(){
    if(document.getElementById("size-chart").classList.contains("is-img-left")){
      document.getElementById("size-chart").classList.remove("is-img-left");
    }
  }, 300);
}

function offchartCart(event) {
  event.target
    .closest(".mini-cart")
    .querySelector("#size-menu")
    .classList.remove("over-lay-active");
  event.target
    .closest(".mini-cart")
    .querySelector("#overlay-size-menu")
    .classList.remove("overlay-active");
  document
    .querySelector("#overlay-size-menu-bg")
    .classList.remove("overlay-active");
}

//mini cart section start

function oncart() {
  document.getElementById("overlay-cart").classList.add("overlay-active");
  document.getElementById("my-cart").classList.add("over-lay-active");
}

function offcart() {
  document.getElementById("overlay-cart").classList.remove("overlay-active");
  document.getElementById("my-cart").classList.remove("over-lay-active");
}

(function () {
  window.inputNumber = function (el) {
    var min = el.attr("min") || false;
    var max = el.attr("max") || false;

    var els = {};

    els.dec = el.prev();
    els.inc = el.next();

    el.each(function () {
      init($(this));
    });

    function init(el) {
      els.dec.on("click", decrement);
      els.inc.on("click", increment);

      function decrement() {
        var value = el[0].value;
        value--;
        if (!min || value >= min) {
          el[0].value = value;
        }
      }

      function increment() {
        var value = el[0].value;
        value++;
        if (!max || value <= max) {
          el[0].value = value++;
        }
      }
    }
  };
})();

inputNumber($(".input-number"));

//inputNumber($('.input-number2'));

inputNumber($(".input-number3"));

$(document).ready(function () {
  
  if ($(window).innerWidth() >= 820) {
    $(document).on("hover", ".has-menu", function(event){
    //$(".has-menu").click(function (event) {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
      } else {
        $(this)
          .parents(".navbar")
          .find(".nav-menu")
          .find(".active")
          .removeClass("active");
        $(this).addClass("active");
      }
    });
  }

  if ($(window).innerWidth() <= 1024) {
    $(document).on("click", ".navbar .has-menu .main-link", function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).parent().find(".sub-menu").slideUp(300);
        $(this).find(".arrow-btn").removeClass("active");
      } else {
        $(this).parents("#mobile-view").find(".has-menu").find(".main-link").removeClass("active");
        $(this).parents("#mobile-view").find(".has-menu").find(".arrow-btn").removeClass("active");
        $(this).parents("#mobile-view").find(".has-menu").find(".sub-menu").slideUp(300);
        $(this).find(".arrow-btn").addClass("active");
        $(this).parent().find(".sub-menu").slideDown(300);
        $(this).addClass("active");
      }
    });
  }

  $(document).on("click", ".filter-action", function(){
    $(".collection-filter").toggleClass("active");
    $("#overlay-mobile").toggleClass("filter-active");
    $("body").toggleClass("no-scroll");
  });

  $(document).on("click", ".mini-cart-btn", function(){
    $(".mini-cart").toggleClass("active");
    $("body").toggleClass("active");
    $("#overlay-cart").addClass("overlay-active");
  });

  $(document).on(
    "click",
    ".cart-header .close-arrow, #overlay-cart, .close-arrow-icon",
    function () {
      $(".mini-cart").toggleClass("active");
      $("body").toggleClass("active");
      $("#overlay-cart").removeClass("overlay-active");
      $("#overlay-size-menu-bg").removeClass("overlay-active");
    }
  );

  $(document).on("click", ".cart-note-slider", function () {
    $("cart-note").slideToggle("");
    $(".cart-note-arrow").toggleClass("active-note");
  });

  $(".menu-img").click(function () {
    $("#mobile-view").addClass("over-lay-active");
    $(".main-mobile-wrap").addClass("active");
    $("body").toggleClass("active");
    $("#overlay-mobile").addClass("overlay-active");
  });

  $(document).on("click", ".close-img", function () {
    $("#mobile-view").removeClass("over-lay-active");
    $(".main-mobile-wrap").removeClass("active");
    $("body").toggleClass("active");
    $("#overlay-mobile").removeClass("overlay-active");
  });

  $("#overlay").click(function () {
    $(".mini-cart").removeClass("active");
    $("body").removeClass("active");
    $("#overlay").removeClass("active");
  });

  $(".slide-table-click").click(function () {
    $(".slide-table-second").toggle();
  });

  $(".slide-table-toggel").click(function () {
    $(".slide-table").toggle();
  });

  $(".offer-slider-box")
    .mouseenter(function () {
      $(this).addClass("hover");
      $(this).parent().addClass("parent-hover");
    })
    .mouseleave(function () {
      $(this).removeClass("hover");
      $(this).parent().removeClass("parent-hover");
    });

  $(document).on("click", ".quick-info-pop .qv-close", function () {
    $(this).parents(".quick-info-pop").removeClass("view-active");
    $(this).parents(".quick-info-pop").find(".quick-info-overlay").toggleClass("active");
    $(this).parents(".quick-info-pop").innerHTML = "";
    $("body").removeClass("no-scroll");
    //$("body").toggleClass("no-scroll");
  });
// =========================================
// =========================================
  // $(document).on("click", ".design-parent-input", function () {
  //   var dataId = $(this).data("id");
  //   if ($(this).hasClass("active")) {
  //     if($(this).parents("var-lists").hasClass("twinning_pro_var_list") == false){
  //       if($(this).parents("var-lists").find("twinning-var").find("#" + dataId).find("input[type='radio']:checked").length == 0){
  //         $(this).removeClass("active");
  //         $(this).find("input[type='radio']:checked").prop("checked", false);
  //         $(this).parents("var-lists").find("twinning-var").find("#" + dataId).slideToggle();
  //       }else{
  //         window.location.reload();
  //       }
  //     }else{
  //       $(this).removeClass("active");
  //       $(this).find("input[type='radio']:checked").prop("checked", false);
  //       $(this).parents("var-lists").find("twinning-var").find("#" + dataId).slideToggle();
  //     }
  //   } else {
  //     $(this).parents("var-lists").find(".design-parent-input").removeClass("active");
  //     $(this).parents("var-lists").find(".parent-set-size").slideUp(".parent-set-size");
  //     $(this).addClass("active");
  //     $(this).parents("var-lists").find("twinning-var").find("#" + dataId).slideToggle();
  //   }
  // });

$(document).ready(function () {
    // Page load check
    if ($(".design-parent-input").hasClass("active")) {
        $(".add-btn-dad-shirt").show();
    } else {
        $(".add-btn-dad-shirt").hide();
    }
});

$(document).on("click", ".design-parent-input", function () {
    var dataId = $(this).data("id");

    if ($(this).hasClass("active")) {
        if ($(this).parents("var-lists").hasClass("twinning_pro_var_list") == false) {
            if ($(this).parents("var-lists").find("twinning-var").find("#" + dataId).find("input[type='radio']:checked").length == 0) {
                $(this).removeClass("active");
                $(this).find("input[type='radio']:checked").prop("checked", false);
                $(this).parents("var-lists").find("twinning-var").find("#" + dataId).slideToggle();
                console.log(dataId + " is now disabled");
                $(".add-btn-dad-shirt").hide();
            } else {
                window.location.reload();
            }
        } else {
            $(this).removeClass("active");
            $(this).find("input[type='radio']:checked").prop("checked", false);
            $(this).parents("var-lists").find("twinning-var").find("#" + dataId).slideToggle();
            console.log(dataId + " is now disabled");
            $(".add-btn-dad-shirt").hide();
        }
    } else {
        $(this).parents("var-lists").find(".design-parent-input").removeClass("active");
        $(this).parents("var-lists").find(".parent-set-size").slideUp(".parent-set-size");
        $(this).addClass("active");
        $(this).parents("var-lists").find("twinning-var").find("#" + dataId).slideToggle();
        console.log(dataId + " is now active");
        $(".add-btn-dad-shirt").show();
    }
});
// =========================================
// =========================================
  $(document).on("click", ".des-detail-tab h3", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).next().slideToggle();
      $(this).parent(".des-detail-tab").removeClass("active");
    } else {
      $(".des-detail-tab").removeClass("active");
      $(".des-detail-tab-inner").slideUp();
      $(".des-detail-tab h3").removeClass("active");
      $(this).next().slideToggle();
      $(this).addClass("active");
      $(this).parent(".des-detail-tab").addClass("active");
    }
  });

  $(".fet-tab a").click(function () {
    if($(this).hasClass("active") == false){
      $(".fet-tab a").removeClass("active");
      $(this).addClass("active");
      var tagid = $(this).data("tag");
      $(".fet-tab-cont").removeClass("active").addClass("hide");
      $("#" + tagid).addClass("active").removeClass("hide");
  
      if ($(this).parents(".gallery").length > 0) {
        const count = parseInt($(this).data("count"));
        $(this).parents(".gallery")
          .find(".fet-tab-cont.active")
          .find(".boxy")
          .slice(0, count)
          .show();
      }
    }
  });

  /*$(".see-more-btn").click(function (e) {
    e.preventDefault();
    const count = parseInt($(this).data("count"));
    $(this).parents(".fet-tab-cont").find(".boxy:hidden").slice(0, count).fadeIn("slow");
    if ($(this).parents(".fet-tab-cont").find(".boxy:hidden").length == 0) {
      $(this).hide();
    }
  });*/

  $(".coll-filter-title").click(function () {
    $(this).next().toggleClass("hide");
    $(this).toggleClass("hide");
  });

  $(".menu-icon .menu-img").click(function () {
    $(".menu-icon .close-img").show();
    $(this).hide();
  });

  $(".menu-icon .close-img").click(function () {
    $(".menu-icon .menu-img").show();
    $(this).hide();
  });

  /* Collection page load more */
  if (
    $(".colle-page").length > 0 ||
    $(".search-page").length > 0 ||
    $(".blog-page").length > 0 ||
    $(".account-page").length > 0
  ) {
    var isMore = false;
    var pageNo;
    var isInProgress = false;
    if ($(".collection-list").find(".tpage").val() > 1) {
      isMore = true;
      $(".collection-list").find(".loading").show();
    }

    $(window).scroll(function () {
      if ($(window).height() + $(window).scrollTop() > $(".collection-list").find(".loading").offset().top) {
        if (isMore && !isInProgress) {
          if (typeof pageNo == "undefined") {
            pageNo = 2;
          } else {
            pageNo++;
          }
          loadMore();
        }
      }
    });

    function loadMore() {
      var url = $(".collection-list .more").find("a").attr("href");
      isInProgress = true;
      $.ajax({
        url: url,
        dataType: "html",
        success: function (html) {
          var $productGrid = $(html).find(".collection-pro-grid").html();
          var new_url = $(html).find(".more").find("a").attr("href");
          $(".collection-list")
            .find(".collection-pro-grid")
            .append($productGrid);
          $(".collection-list").find(".more").find("a").attr("href", new_url);
          isInProgress = false;

          if (pageNo == parseInt($(".collection-list").find(".tpage").val())) {
            $(".collection-list").find(".loading").hide();
            isMore = false;
          }

          let largeSliders = document.querySelector(".collection-list").querySelectorAll(".fet-tab-pro-img-inner");
          largeSliders.forEach((slider, index) => {
            if (!slider.classList.contains("swiper-initialized")) {
              new Swiper(slider, {
                slidesPerView: 1,
                speed: 1000,
                loop: true,
                navigation: {
                  nextEl: ".fet-inner-next",
                  prevEl: ".fet-inner-prev",
                },
              });
            }
          });
          setTimeout(function () {
            //AddZeroReviewText();
          }, 3000);
        },
      });
    }
  }

  // Sticky header start

  var didScroll;
  var lastScrollTop = 0;
  var delta = 0;
  var navbarHeight = $('header').outerHeight();

  $(window).scroll(function (event) {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 500);

  function hasScrolled() {
    var st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta)
      return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $('.main-header').addClass('hide-nav');
      $('body').removeClass('show-nav'); 
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        $('.main-header').removeClass('hide-nav');
        $('body').addClass('show-nav');
      }
    }
    lastScrollTop = st;
  }
  // Sticky header end
});

function onchart2() {
  //event.preventDefault();
  document.getElementById("overlay-size-menu").classList.add("overlay-active");
  document.getElementById("overlay-size-menu-bg").classList.add("overlay-active");
  document.getElementById("size-menu").classList.add("over-lay-active");
  document.body.classList.add("no-scroll");
}

function offchart2() {
  document.getElementById("overlay-size-menu").classList.remove("overlay-active");
  document.getElementById("overlay-size-menu-bg").classList.remove("overlay-active");
  document.querySelector(".mini-cart-size-menu").classList.remove("over-lay-active");
  document.body.classList.remove("no-scroll");
}

function onmobile() {
  document.getElementById("overlay-mobile").classList.add("overlay-active");
  document.getElementById("mobile-view").classList.add("over-lay-active");
  document.body.classList.add("no-scroll");
}

function offmobile() {
  document.getElementById("overlay-mobile").classList.remove("overlay-active");
  document.getElementById("mobile-view").classList.remove("over-lay-active");
  document.body.classList.remove("no-scroll");
}

/* Footer newsletter validation */
var emailRegex =
  /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
if (document.querySelector(".newsletter_btn")) {
  document
    .querySelector(".newsletter_btn")
    .addEventListener("click", function (event) {
      const form = this.closest("form");
      const email = form.querySelector(".email");
      const errMsg = form.querySelector(".error-msg");
      errMsg.innerHTML = "";

      if (!email.value) {
        email.focus();
        errMsg.innerHTML = "Enter your email address";
        errMsg.classList.remove("hidden-class");
        event.preventDefault();
      } else if (!email.value.match(emailRegex)) {
        email.focus();
        errMsg.innerHTML = "Enter your valid email address";
        errMsg.classList.remove("hidden-class");
        event.preventDefault();
      } else {
        return true;
      }
    });
}

/* Register page validation */
if (document.querySelector(".register_btn")) {
  document
    .querySelector(".register_btn")
    .addEventListener("click", function (event) {
      const form = this.closest("#create_customer");
      const firstname = form.querySelector(".firstname");
      const lastname = form.querySelector(".lastname");
      const email = form.querySelector(".email");
      const pass = form.querySelector(".password");
      const errMsg = form.querySelector(".err-msg");
      errMsg.innerHTML = "";

      if (!firstname.value) {
        firstname.focus();
        errMsg.innerHTML = "Enter your first name";
        event.preventDefault();
      } else if (!lastname.value) {
        lastname.focus();
        errMsg.innerHTML = "Enter your last name";
        event.preventDefault();
      } else if (!email.value) {
        email.focus();
        errMsg.innerHTML = "Enter your email address";
        event.preventDefault();
      } else if (!email.value.match(emailRegex)) {
        email.focus();
        errMsg.innerHTML = "Enter your valid email address";
        event.preventDefault();
      } else if (!pass.value) {
        pass.focus();
        errMsg.innerHTML = "Enter your password";
        event.preventDefault();
      } else if (pass.value.length < 5) {
        pass.focus();
        errMsg.innerHTML = "Password is too short (minimum is 5 characters)";
        event.preventDefault();
      } else {
        return true;
      }
    });
}

/* Login page validation */
if (document.querySelector(".login_submit_btn")) {
  document
    .querySelector(".login_submit_btn")
    .addEventListener("click", function (event) {
      const form = this.closest("#customer_login");
      const email = form.querySelector(".email");
      const pass = form.querySelector(".login_password");
      const errMsg = form.querySelector(".err-msg");
      errMsg.innerHTML = "";

      if (!email.value) {
        email.focus();
        errMsg.innerHTML = "Enter your email address";
        event.preventDefault();
      } else if (!email.value.match(emailRegex)) {
        email.focus();
        errMsg.innerHTML = "Enter your valid email address";
        event.preventDefault();
      } else if (!pass.value) {
        pass.focus();
        errMsg.innerHTML = "Enter your password";
        event.preventDefault();
      } else {
        return true;
      }
    });
}

/* Recover page validation */
if (document.querySelector(".recover_btn")) {
  document
    .querySelector(".recover_btn")
    .addEventListener("click", function (event) {
      const form = this.closest("#recover_customer_password");
      const email = form.querySelector(".recover_email");
      const errMsg = form.querySelector(".err-msg");
      errMsg.innerHTML = "";

      if (!email.value) {
        email.focus();
        errMsg.innerHTML = "Enter your email address";
        event.preventDefault();
      } else if (!email.value.match(emailRegex)) {
        email.focus();
        errMsg.innerHTML = "Enter your valid email address";
        event.preventDefault();
      } else {
        return true;
      }
    });
}

/* Contact us page validation */
if (document.querySelector(".contact_btn")) {
  document
    .querySelector(".contact_btn")
    .addEventListener("click", function (event) {
      const form = this.closest("form");
      const err = form.querySelector(".error-msg");
      const parent_name = form.querySelector(".parent_name");
      const phone = form.querySelector(".phone");
      const email = form.querySelector(".email");
      const msg = form.querySelector(".message");
      err.innerHTML = "";

      if (parent_name.value == "") {
        parent_name.focus();
        err.innerHTML = "Enter parent's name";
        event.preventDefault();
      } else if (!phone.value) {
        phone.focus();
        err.innerHTML = "Enter mobile number";
        event.preventDefault();
      } else if (!email.value) {
        email.focus();
        err.innerHTML = "Enter email address";
        event.preventDefault();
      } else if (!email.value.match(emailRegex)) {
        email.focus();
        err.innerHTML = "Enter valid email address";
        event.preventDefault();
      } else if (msg.value.length == 0) {
        msg.focus();
        err.innerHTML = "Enter your enquiry";
        event.preventDefault();
      }
    });
}

/* Activate account page validation */
if (document.querySelector(".active_btn")) {
  document
    .querySelector(".active_btn")
    .addEventListener("click", function (event) {
      const form = this.closest("form");
      const pass1 = form.querySelector(".password1");
      const pass2 = form.querySelector(".password2");
      const errMsg = form.querySelector(".err-msg");
      errMsg.innerHTML = "";

      if (!pass1.value) {
        pass1.focus();
        errMsg.innerHTML = "Enter your password";
        event.preventDefault();
      } else if (!pass2.value) {
        pass2.focus();
        errMsg.innerHTML = "Enter your confirm password";
        event.preventDefault();
      } else if (pass1.value != pass2.value) {
        pass2.focus();
        errMsg.innerHTML = "The password does not match the confirmed passwor";
        event.preventDefault();
      } else {
        return true;
      }
    });
}

/*   Address pages validation   */
$(document).on("click", ".add_new_address, .edit_address", function(e) {
  var form = $(this).parents("form");
  var firstname = form.find(".add_firstname");
  var lastname = form.find(".add_lastname");
  var company = form.find(".add_company");
  var phone = form.find(".add_phone");
  var address = form.find(".add_address"); 
  var city = form.find(".add_city");
  var zip = form.find(".add_zip"); 
  var country = form.find(".add_country");
  var errMsg = form.find(".err-msg");
  errMsg.remove();

  if(firstname.val() == ''){
    firstname.parent(".form__input-wrapper").append("<p class='err-msg'>Enter your first name</p>");
    firstname.focus();
    return false;
  }else if(lastname.val() == ''){
    lastname.parent(".form__input-wrapper").append("<p class='err-msg'>Enter your last name</p>");
    lastname.focus();      
    return false;
  }else if(company.val() == ''){
    company.parent(".form__input-wrapper").append("<p class='err-msg'>Enter your company name</p>");
    company.focus();
    return false;
  }else if(address.val() == ''){
    address.parent(".form__input-wrapper").append("<p class='err-msg'>Enter your address</p>");
    address.focus();      
    return false;
  }else if(city.val() == ''){
    city.parent(".form__input-wrapper").append("<p class='err-msg'>Enter your city</p>");
    city.focus();
    return false;
  }else if(country.val() == '---'){
    country.parent(".select-wrapper").append("<p class='err-msg'>select your country</p>");
    country.focus();      
    return false;
  }else if(phone.val() == ''){
    phone.parent(".form__input-wrapper").append("<p class='err-msg'>Enter your phone number</p>");
    phone.focus();      
    return false;
  }else if(zip.val() == ''){
    zip.parent(".form__input-wrapper").append("<p class='err-msg'>Enter your zipcode</p>");
    zip.focus();      
    return false;
  }else{
    return true;
  }
});

/*       Article page comment form validation       */
if (document.querySelector(".comment_btn")) {
  document
    .querySelector(".comment_btn")
    .addEventListener("click", function (event) {
      const form = this.closest("form");
      const name = form.querySelector(".author_name");
      const email = form.querySelector(".author_email");
      const comment = form.querySelector(".author_comment");
      const errMsg = form.querySelector(".error-msg");
      errMsg.innerHTML = "";

      if(!name.value) {
        name.focus();
        errMsg.innerHTML = "Enter your name";
        event.preventDefault();
      }else if (!email.value) {
        email.focus();
        errMsg.innerHTML = "Enter your email address";
        event.preventDefault();
      }else if (!email.value.match(emailRegex)) {
        email.focus();
        errMsg.innerHTML = "Enter your valid email address";
        event.preventDefault();
      }else if (!comment.value) {
        comment.focus();
        errMsg.innerHTML = "Enter your comment";
        event.preventDefault();
      }else {
        return true;
      }
    });
}

/*        Address page        */
$(document).on("click", ".add-new-address", function () {
  $(this)
    .parents(".address_page")
    .find("#modal-address-new")
    .toggleClass("hidden-class");

  $(this)
    .parents(".address_page")
    .find(".edit-address-form")
    .addClass("hidden-class");

  var header = $("[data-section-id='header']").height();
  var add_address_sec = $("#modal-address-new").offset().top;
  var total = parseInt(add_address_sec-header);
  $('html, body').animate({
    scrollTop: total
  }, 500);
});

$(document).on("click", ".cancel_btn", function () {
  $(this).parents(".modal").addClass("hidden-class");
  $('html, body').animate({
    scrollTop: 0
  }, 500);
});

$(document).on("click", ".edit-address-btn", function () {
  if (
    $(this)
      .parents(".address_page")
      .find("#" + $(this).data("id"))
      .hasClass("hidden-class")
  ) {
    $(this)
      .parents(".address_page")
      .find(".edit-address-form")
      .addClass("hidden-class");

    $(this)
      .parents(".address_page")
      .find("#" + $(this).data("id"))
      .toggleClass("hidden-class");

    $(this)
      .parents(".address_page")
      .find("#modal-address-new")
      .addClass("hidden-class");

    var header = $("[data-section-id='header']").height();
    var edit_address_sec = $("#" + $(this).data("id")).offset().top;
    var total = parseInt(edit_address_sec-header);
    $('html, body').animate({
      scrollTop: total
    }, 500);
  } else {
    $(this)
      .parents(".address_page")
      .find("#" + $(this).data("id"))
      .toggleClass("hidden-class");

    $('html, body').animate({
      scrollTop: 0
    }, 500);
  }
});

/* collection short by filter */

$(document).on("click", ".scroll-content .select-order", function () {
  if($(window).width() < 767){
    $(this).parents(".collection-list-top").find(".filter-action").trigger("click");
    if($(".filter-menu").find(".filter-group-sort-orders").length > 0){
      $(".collection-filter").animate({
        scrollTop: $('.filter-group-sort-orders').offset().top 
      }, 500);
    }
  }else{
    $(".scroll-content .nav-sort-orders").toggleClass("sort-order-active");
    $(this).toggleClass("sort-btn-active"); 
  }
});

function AddZeroReviewText() {
  $(".junip-product-summary-review-count").each(function (index) {
    var count = $(this).text().trim().replace("(", "").replace(")", "");
    $(this).text("");
    const string = `${count} Review${count == 1 ? "" : "s"}`;
    $(this).text(string);
  });
}

const close_btn = '<div class="close close-size-chart" onclick="offchart()"><img src="https://cdn.shopify.com/s/files/1/0558/0734/4717/files/12673.png" alt="close"></div>';
$(document).on("click", ".size-guide img", function(ev){
  var img = "<img src='"+$(this).attr("src")+"'>";
  //const close_btn = '<div class="close close-size-chart" onclick="offchart()"><img src="https://cdn.shopify.com/s/files/1/0558/0734/4717/files/12673.png" alt="close"></div>';
  $(".size-chart-home").find("#size-chart").html(close_btn+img);
  onchart(ev);
});

$(document).on("click", ".account-tab .selected-order", function () {
  $(".account-tab .act-dropdown").toggleClass("show");
  $(this).toggleClass("active");
});

/*$(document).on("click", ".offer-banner .offer-banner-box", function (){
  console.log($(this).hasClass("swiper-slide-active"));
  if($(this).hasClass("swiper-slide-active")){
    console.log($(this).find("a").attr('href'));
    window.location.href = $(this).find("a").attr('href');
  }
});*/

$(document).on("click", ".product_page .design-style .style-img-wrap-in", function(ev){
  $(".size-chart-home").find(".size-chart-box").addClass("media-popup");
  const pagin = '<div class="swiper-button-next media-button-next"></div><div class="swiper-button-prev media-button-prev"></div>';
  const loader = '<div class="loading"></div>';
  const slider_data = $(this).parents(".design-left-inner").find(".pro-img-wrap")[0].outerHTML;
  $(".size-chart-home").find("#size-chart").removeClass("hide-loader");
  
  document.getElementById("overlay-size-chart").classList.add("overlay-active");
  document.getElementById("size-chart").classList.add("over-lay-active");
  $(".size-chart-home").find("#size-chart").append(loader);
  
  setTimeout(() => {
    $(".size-chart-home").find("#size-chart").html(close_btn+slider_data);
    $("#size-chart").find("div").eq(1).removeClass();
    $("#size-chart").find("div").eq(1).addClass("new-slider");
    $(".size-chart-home").find("#size-chart").find(".new-slider").append(pagin);
    ProductImageSlider('.new-slider', $(this).parent().index());
    $(".size-chart-home").find("#size-chart").addClass("hide-loader");
    $("body").addClass("no-scroll");
    $(".media-popup").find(".style-img-wrap-in").addClass("zoom-box");
    if($(window).width() >= 768) {
      $('.zoom-box').izoomify();
    }
    if($(window).width() < 768) {
     var el = document.querySelectorAll('div.zoom-box');
     el.forEach(function (zoomel) {
       new PinchZoom.default(zoomel, {});
     })
    }
  }, 600);

  /*setTimeout(() => {  
    document.getElementById("size-chart").classList.add("over-lay-active");
  }, 900);*/  
});


/*   Functiom for product page image slider   */
function ProductImageSlider(cls, index){
  var proSlider = new Swiper(cls, {
    slidesPerView: 1,
    centeredSlides: true,
    loop: false,
    touchRatio: 0,
    navigation: {
      nextEl: ".media-button-next",
      prevEl: ".media-button-prev",
    },
    on: {
      transitionStart: function(){
        var videos = document.querySelectorAll('.swiper-slide video');
        Array.prototype.forEach.call(videos, function(video){
          video.pause();
        });
    
        $(cls+' .iframe-video').each(function(){
          this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
        });
    
        if($(cls).find('iframe.vimeo-video').length !== 0 ){
          var iframe = $('iframe.vimeo-video')[0];
          var player = new Vimeo.Player(iframe);
          player.pause();
        }
      },
      transitionEnd: function(){
        var activeIndex = this.activeIndex;
        var activeSlide = document.querySelector(cls).getElementsByClassName('swiper-slide')[activeIndex];
        if(activeSlide.querySelector(".thumb_video")){
          var activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
          activeSlideVideo.play();
        }
    
        if(activeSlide.querySelector(".iframe-video")){
          var activeSlideIframe = activeSlide.getElementsByTagName('iframe')[0];
          activeSlideIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
        }
    
        if(activeSlide.querySelector(".vimeo-video")){
          var activeSlideVimeo = activeSlide.getElementsByClassName('vimeo-video')[0];
          var playerVimeo = new Vimeo.Player(activeSlideVimeo);
          playerVimeo.play();
        }
      }
    }
  });
  if(index != ''){
    proSlider.slideTo(index, false,false);
  }
}

/*   Functiom for product variant option scroll   */
function setScrollOnColorOption(option, className){
  var instance = $("."+className);
  if(className == 'var-main-class'){
    var indexLimit = 7;
  }else if(className == 'parent-set-size'){
    var indexLimit = 5;
  }

  $.each( instance, function(key, value) {
    
    $(instance[key]).find("fieldset").each(function(){
      if($(this).find(".design-set-size-tabs").length > 0){
        var columnGap = parseInt($(this).find(".design-set-size-tabs").css("column-gap").replace("px", ""));
        var wd = 0;
        if(option == 'multi-option'){
          $(this).find(".design-set-size-tabs .swatch-element.available").each(function(index){
            index > 0 ? wd+= $(this).innerWidth()+columnGap : wd+= $(this).innerWidth();
          });
        }else{
          $(this).find(".design-set-size-tabs .coll-filter").each(function(index){
            if(index < indexLimit){
              index > 0 ? wd+= $(this).innerWidth()+columnGap : wd+= $(this).innerWidth();
            }
          });
        }
      
        //console.log(wd, $(this).find(".design-set-size-tabs").innerWidth())
        if(wd > $(this).find(".design-set-size-tabs").innerWidth()){
          $(this).find(".size-scroll").removeClass("hide");
        }else{
          $(this).find(".size-scroll").addClass("hide");
        }

        let isDown = false;
        let startX;
        let scrollLeft;
        var arrows = $(this).find(".size-scroll"),
            prevArrow = arrows.filter('#size-left-button'),
            nextArrow = arrows.filter('#size-right-button'),
            box = $(this).find(".design-set-size-tabs"), 
            x = 0,
            mx = 0,
            maxScrollWidth = box[0].scrollWidth - (box[0].clientWidth / 2) - (box.width() / 2);

        $(arrows).on('click', function() {
          if ($(this).data("name") == "next") {
            x = ((box.width() / 2)) + box.scrollLeft() - 10;
            box.animate({
              scrollLeft: x + 5,
            })
          } else {
            x = ((box.width() / 2)) - box.scrollLeft() - 8;
            box.animate({
              scrollLeft: -x,
            })
          } 
        });

        $(box).on({
          mousedown: function(e) {
            isDown = true;
            startX = e.pageX - this.offsetLeft;
            scrollLeft = this.scrollLeft;
          },
          mouseup: function(e) {
            isDown = false;
          },
          mouseleave: function(e) {
            isDown = false;
          },
          mousemove: function(e) {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - this.offsetLeft;
            const walk = (x - startX) * 0.5; //scroll-fast
            this.scrollLeft = scrollLeft - walk;
          },
          scroll: function() {
            toggleArrows();
          }
        });

        $(document).on("mouseup", function(){
          mx = 0;
        });
        $(document).on("mouseleave", function(){
          mx = 0;
        });
        
        function toggleArrows() {
          if(box.scrollLeft() > maxScrollWidth - 10) {
            nextArrow.addClass('disabled');
            prevArrow.removeClass('disabled');
          } else if(box.scrollLeft() < 10) {
            prevArrow.addClass('disabled');
            nextArrow.removeClass('disabled');
          } else{
            nextArrow.removeClass('disabled');
            prevArrow.removeClass('disabled');
          }
        }
      }
    });
  });
}